import React from 'react';
import { token } from '@atlaskit/tokens';
import { useJiraSoftwareProjectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { SIDEBAR_ID } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/constants.tsx';
import {
	SidebarReady,
	SidebarRenderStart,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/main.tsx';
import { SidebarThemeProvider } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/sidebar-theme/index.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/skeleton/index.tsx';
import { Menu } from './menu/main.tsx';

export const SidebarNextGen = () => {
	const { data, loading } = useJiraSoftwareProjectNavigation();
	if (loading || data == null) {
		return <Skeleton isFull />;
	}

	return (
		<>
			<SidebarRenderStart />

			<SidebarThemeProvider theme={THEME}>
				<Menu />
			</SidebarThemeProvider>

			{!__SERVER__ && <SidebarReady id={SIDEBAR_ID.JSW_NEXT_GEN} />}
		</>
	);
};

const menuItemActiveHoverColor = token('color.background.selected');
const THEME = {
	navigation: {
		item: {
			background: {
				default: 'transparent',
				active: menuItemActiveHoverColor,
				hover: menuItemActiveHoverColor,
			},
			color: {
				active: `${token('color.text.selected')}`,
			},
		},
	},
} as const;
